<template>
  <div>
    <div style="padding: 20px 0 0">
      <el-form :inline="true" :model="formInline" label-position="left" @keydown.native.enter="onSubmit"
        class="demo-form-inline">
        <el-form-item label="发货编号：">
          <el-input maxlength='450' v-model="formInline.code" placeholder="请填入发货编号"></el-input>
        </el-form-item>
        <el-form-item label="批次包编码：">
          <el-input maxlength='450' v-model="formInline.pkgCode" placeholder="请输入批次包编码"></el-input>
        </el-form-item>
        <el-form-item label="采购单号：">
          <el-input maxlength='450' v-model="formInline.purchaseNo" placeholder="请填入采购单号"></el-input>
        </el-form-item>
        <el-form-item label="异常采购单号：">
          <el-input maxlength='450' v-model="formInline.purchaseAbnormalNo" placeholder="请填入异常采购单号"></el-input>
        </el-form-item>
        <el-form-item label="退货截止时间：">
          <el-date-picker v-model="formInline.deadline" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
            :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="退货截止开始时间"
            @change="timeChange" end-placeholder="退货截止结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="restSubmit">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="padding: 0 0 20px; display: flex; justify-content: flex-start">
        <!-- <el-button type="primary" icon="el-icon-document" :disabled="!selectedRows.length" @click="exportShipInvoice">
          导出发货单
        </el-button> -->
        <!--        只有待处理的才能生成拣货任务 start-->
        <el-button v-if="listType === '0'" type="primary" @click="createPack" :disabled="!selectedRows.length">批量打印拣货任务
        </el-button>
        <el-button v-if="listType === '1'" type="primary" @click="batchUpd" :disabled="!selectedRows.length">批量保存
        </el-button>
        <el-button type="primary" @click="exportOut">导出
        </el-button>
        <!--        只有待处理的才能生成拣货任务 end-->

      <el-upload v-if="listType === '1'" class="uploader" action="actionUrl" :http-request="uploadToOSS"
        :show-file-list="false" accept=".xlsx,.xls">
        <el-button type="primary">表格上传
        </el-button>
      </el-upload>

      <a v-if="listType === '1'" href="https://theckbs-oss.theckbs.com/wmsxls/退货单物流导入模板.xlsx" target="_blank">
        <el-button type="primary">模板下载
        </el-button>
      </a>
    </div>
    <WmsTable :columns="columns" :dataSource="dataSource" is-row-selection @selectChange="selectChangeCall"
      @pageChange="pageChangeCall" :preserveSelectedRowKeys="false" :isPagination="query" >
      <div slot="productImgAction" slot-scope="{ text, record, index }" style="display: flex; align-items: center">
        <ImgView :src="text" width="80" height="80" v-if="text" />
        <div style="margin-left: 10px;word-break: break-all;">{{ record.productName || '-' }}</div>
      </div>
      <div slot="returnDeadlineTime" slot-scope="{ text, record, index }">
        <div style="color: red">{{ record.returnDeadlineTime }}</div>
      </div>
      <div slot="expressNoAction" slot-scope="{ text, record, index }">
        <!--        添加物流单号的只有 打包中 start-->
        <div v-if="listType === '1'" style="display: flex">
          <el-input maxlength='450' v-model="record.logisticsNo"></el-input>
          <span class="span__btn" style="color: rgb(64, 169, 255); margin-left: 10px" @click="maintainExpress(record)">确认发货</span>
        </div>
        <!--        展示物流单号的只有 已发货 start-->
        <span class="span__btn" v-else-if="listType === '2'" style="color: orange">{{ text }}</span>
        <!--        其他状态的展示 ———— start-->
        <span class="span__btn" v-else>——</span>
        <!--        其他状态的展示 ———— end-->
      </div>
      <div slot="action" slot-scope="{ text, record, index }" class="action__div--flex" v-if="listType == 0">
        <span class="span__btn" style="color: #008dde" @click="singleCreatePack(record)">打印拣货任务</span>
      </div>
    </WmsTable>
    <div class="startprint" ref="startprint">
      <el-table :data="printData" size="medium">
        <el-table-column label="批次包编码" prop="pkgCode">
        </el-table-column>
        <el-table-column label="数量" prop="deliveryNum"></el-table-column>
        <el-table-column label="货格码" prop="gridCode"></el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="dialogShow" @close="dialogClose">
      <div slot="title" class="dialogTitle">收货地址修改提醒</div>
      <div style="text-align:left;color:red;font-size:20px">以下退货单收货地址变更，请确认</div>
      <el-table :data="dialogData" height="500px" border style="width:100%">
        <el-table-column label="发货编号" prop="deliveryTaskCode">
        </el-table-column>
        <el-table-column label="批次号" prop="pkgCode">
        </el-table-column>
        <el-table-column label="原地址" prop="pkgCode">
          <template slot-scope="scope">
            <div>{{ scope.row.originalReceiver }} {{ scope.row.originalMobile }}</div>
            <div>{{ scope.row.originalAddress }}</div>
          </template>
        </el-table-column>
        <el-table-column label="新地址" prop="pkgCode">
          <template slot-scope="scope">
            <div>{{ scope.row.receiver }} {{ scope.row.mobile }}</div>
            <div>{{ scope.row.address }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:right">
        <el-pagination background layout="total, sizes, prev, pager, next" :total="dialogTotal"
          @current-change="dialogPageChange" @size-change="dialogSizeChange" :page-size="dialogPage.pageSize">
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="confirmShow" width="400px" append-to-body :close-on-press-escape="false" :close-on-click-modal='false'>
      <div slot="title" class="dialogTitle">确认发货</div>
      <p>
        总共有{{ syncNumber + 1 }}单具有同样的收件人、手机号、收件地址，是否同步更新物流单号？
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmSync(false,'此')">不需要同步</el-button>
        <el-button type="primary" @click="confirmSync(true,'部分')">同步更新</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import Calendar from "@/utils/calendar";
import moment from "moment"
import {
  columns,
  logisticsNo,
  action,
} from "@/views/outOfDomestic/domesticShipment/returnGoods/components/ComTableData";
import {
  domesticList,
  printTask,
  updExpressNo,
  batchExpressNo,
  bratchPrint,
  unDeliveryAblepage,
  exportReturnItem, importTrackingNumber,
  getModifyAddressFlag,
  queryRecipient
} from "@/apis/outDomestic";
import {createPickTask} from '@/apis/outStock'
import { MessageBox } from 'element-ui';


export default {
  name: "ComTable",
  components: {
    WmsTable,
    ImgView,
  },
  props: {
    listType: {
      type: String, // tab 页类型
      required: true,
    },
  },
  data() {
    return {
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      expressNo: "",
      formInline: {
        code: "",
        pkgCode: "",
        deadline: '',
      },
      returnDeadlineStartTime: '',
      returnDeadlineEndTime: '',
      columns,
      dataSource: [],
      selectedRows: [],
      printData: [],

      dialogPage: { pageNum: 1, pageSize: 10 },
      dialogData: [],
      dialogShow: false,
      dialogTotal: 0,
      event: "",
      confirmShow:false,
      syncNumber: ''
    };
  },
  mounted() {
    let col = [...this.columns];
    if (this.listType == 0) {
      col.push(action);
    } else if (this.listType != 3) {
      col.push(logisticsNo);
    }
    this.columns = col;
  },
  methods: {
    onSubmit: function () {
      let params = Object.values(this.formInline);
      let canSubmit = 0;
      params.forEach((item, index) => {
        if (item) {
          canSubmit += 1;
        }
      });
      if (canSubmit > 1) {
        this.$message.warning("搜索条件错误，请单个搜索");
        return;
      }
      this.query.current = 1
      this.getDomesticList();
    },
    restSubmit: function () {
      Object.keys(this.formInline).forEach(key => { this.formInline[key] = undefined })
      this.returnDeadlineStartTime = ''
      this.returnDeadlineEndTime = ''
      this.onSubmit(undefined, "rest");
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current
      this.query.pageSize = pageSize
      this.getDomesticList(true);
    },
    selectChangeCall: function (rows) {
      this.selectedRows = rows;
    },
    getList: function () {
      for (let i = 0; i < 20; i++) {
        this.dataSource.push({
          ...dataSourceMap,
          id: Math.random().toFixed(8),
        });
      }
      this.query.total = 100;
    },
    getDomesticList: function (getModifyAddressFlagData = false) {
      let getData = this.listType != 3 ? domesticList : unDeliveryAblepage
      let params = {
        domesticDeliveryStatus: this.listType != 3 ? this.listType : undefined,
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        deliveryTaskCode: this.formInline.code || undefined,
        pkgCode: this.formInline.pkgCode || undefined,
        returnDeadlineEndTime: this.returnDeadlineEndTime || undefined,
        returnDeadlineStartTime: this.returnDeadlineStartTime || undefined,
        purchaseNo: this.formInline.purchaseNo || undefined,
        purchaseAbnormalNo: this.formInline.purchaseAbnormalNo || undefined
      };
      getData(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
      if (this.listType == "1" && getModifyAddressFlagData) {
        this.getModifyAddressFlagData()
      }
    },
    getModifyAddressFlagData() {
      return new Promise((resolve) => {
        getModifyAddressFlag({ ...this.dialogPage }).then(({ code, data }) => {
          if (code === 0) {
            console.log(data)
            if (data.records.length > 0) {
              this.dialogTotal = data.total
              this.dialogData = data.records
              this.dialogShow = true
            }
              resolve(data)
          }
        })
      })
    },
    dialogPageChange(r) {
      this.dialogPage.pageNum = r
      this.getModifyAddressFlagData()
    },
    dialogSizeChange(r) {
      this.dialogPage.pageSize = r
      this.getModifyAddressFlagData()
    },
    dialogClose() {
      if (this.event) {
        this.event()
        this.event = ''
      }
    },
    batchUpd: function () {
      let that = this;
      let params = [];
      for (let i = 0; i < that.selectedRows.length; i++) {
        if (
          that.selectedRows[i].logisticsNo &&
          that.selectedRows[i].logisticsNo != ""
        ) {
          params.push({
            deliveryTaskCode: that.selectedRows[i].deliveryTaskCode,
            logisticsNo: that.selectedRows[i].logisticsNo,
          });
        } else {
          this.$message.warning("请填写快递单号");
          return;
        }
      }

      this.getModifyAddressFlagData().then(res => {
        this.event = function () {
          batchExpressNo(params).then(({ code, data }) => {
            if (code === 0) {
              this.getDomesticList();
              this.$message.success("成功");
            }
          });
        }
        if (res.records.length == 0) {
          this.dialogClose()
        }
      })
    },
    async confirmSync(type){
      this.confirmShow=false
      this.confirmSync._t(type,type?'部分':'此')
    },
    maintainExpress: async function (r) {
      if (r.logisticsNo && r.logisticsNo != "") {
        const _t=(type = false,tip='部分')=>{
        let params = {
          deliveryTaskCode: r.deliveryTaskCode,
          logisticsNo: r.logisticsNo,
          needSync:type
        };
          this.getModifyAddressFlagData().then(res => {
            this.event = function () {
              updExpressNo(params).then(({ code, data }) => {
                if (code === 0) {
                  this.$message.success("成功");
                  this.getDomesticList();
                  if(data.overdueDeliveryTaskCodeList && data.overdueDeliveryTaskCodeList.length && type){
                    MessageBox.alert(`${tip}单据已超过退货截止时间，状态变为无法退货，无法确认发货`, `${tip}单据无法退货`, {
                      confirmButtonText:'我知道了'
                    })
                  }
                }
              });
            }
            if (res.records.length == 0) {
              this.dialogClose()
            }
          })
        }
        // 超过1条则展示弹窗 暂时不走这个流程
        const list =await queryRecipient(r.deliveryTaskCode).then(res=>res?.success?res.data:[])
        if(list.length>0) {
          this.confirmSync._t=_t
          this.confirmShow=true
          this.syncNumber=list.length
        } else {
          _t()
        }
      } else {
        this.$message.warning("请填写物流单号");
      }
    },
    exportShipInvoice: function () { },
    createPack: function () {
      let deliveryTaskCodeList = [];
      this.selectedRows.forEach((item) => {
        deliveryTaskCodeList.push(item.deliveryTaskCode);
      });
      let params = {
        deliveryTaskCodeList: deliveryTaskCodeList,
        pickType: 5
      };
      // this.createPackUpd(params,'batch')
      bratchPrint(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.getDomesticList();
        }
      });
    },
    singleCreatePack: function (record) {
      let params = {
        deliveryTaskCode: record.deliveryTaskCode,
      };
      printTask(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.printData = [record]
          this.$nextTick((_) => {
            let printDiv = this.$refs.startprint
            console.log(this.$refs)
            console.log(printDiv)
            let app = document.getElementById('app')
            app.style.opacity = 0
            printDiv.style['z-index'] = 9
            document.body.appendChild(printDiv);
            window.print();
            app.style.opacity = 1
            printDiv.style['z-index'] = -9
            this.getDomesticList();
          });
        }
      });
      // let params = {
      //   deliveryTaskCodeList: [record.deliveryTaskCode],
      //   pickType: 5
      // };
      // this.createPackUpd(params,'single',record)
    },
    createPackUpd:function(params,type='single',record=false){
      let that = this
      createPickTask(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.getDomesticList();
          if(data && data.length){
            let tip = type === 'single' ? '此' : '部分'
            this.$confirm(`${tip}单据已超过退货截止时间，状态变为无法退货，无法生成拣货任务`, `${tip}单据无法退货`, {
              confirmButtonText: "我知道了",
              type: "error",
              showCancelButton:false,
              closeOnPressEscape:false,
              closeOnClickModal:false
            }).finally(()=>{
              this.getDomesticList();
            });
          }
          // this.$nextTick((_) => {
          //   if(!record || type=='single'&& (data && data.length)){
          //     return false
          //   }
          //   that.printData = [record]
          //   let printDiv = this.$refs.startprint
          //   console.log(this.$refs)
          //   console.log(printDiv)
          //   let app = document.getElementById('app')
          //   app.style.opacity = 0
          //   printDiv.style['z-index'] = 9
          //   document.body.appendChild(printDiv);
          //   window.print();
          //   app.style.opacity = 1
          //   printDiv.style['z-index'] = -9
          //   this.getDomesticList();
          // });
        }else if(code == '26000011'){
          this.$confirm('当前拣货任务所需分拣框数量超过可用的分拣框数量', "分拣框不足", {
            confirmButtonText: "去新建分拣框",
            type: "error",
            cancelButtonText: "取消",
              closeOnPressEscape:false,
              closeOnClickModal:false
          }).then(() => {
            that.$router.push({ name: "ConfigureBasket",params:{openAdd:true} });
          });
        }
      });
    },
    exportOut() {
      let params = {
        "deliveryAble": this.listType != '3' ? 1 : 0,
        domesticDeliveryStatus: this.listType != 3 ? this.listType : undefined,
        deliveryTaskCode: this.formInline.code || undefined,
        pkgCode: this.formInline.pkgCode || undefined,
        returnDeadlineEndTime: this.returnDeadlineEndTime || undefined,
        returnDeadlineStartTime: this.returnDeadlineStartTime || undefined,
      };
      if (this.selectedRows.length > 0) {
        params = {
          deliveryTaskCodeList: this.selectedRows.map(item => {
            return item.deliveryTaskCode
          })
        }
      }
      const date = Calendar.d1(Date.now());
      exportReturnItem(params).then((res) => {
        console.log(res)
        let blobObj = new Blob([res.data], { type: "application/octet-stream" });
        let blobUrl = window.URL.createObjectURL(blobObj);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = date + "国内发货单.xls";
        link.click();
        window.URL.revokeObjectURL(link.href);
      });
    },
    timeChange: function (val) {
      if (!val) {
        this.formInline.deadline = null;
        this.returnDeadlineStartTime = '';
        this.returnDeadlineEndTime = '';
        return;
      }
      this.returnDeadlineStartTime = moment(val[0]).format("YYYY-MM-DD HH:mm:ss");
      this.returnDeadlineEndTime = moment(val[1]).format("YYYY-MM-DD HH:mm:ss");
    },
    uploadToOSS(res) {
      let forms = new FormData();
      forms.append("file", res.file);

      this.getModifyAddressFlagData().then(res => {
        this.event = function () {
          importTrackingNumber(forms).then(({ code, data }) => {
            if (code == 0) {
              this.$message.success("成功");
              this.getDomesticList()
            }
          });
        }
        if (res.records.length == 0) {
          this.dialogClose()
        }
      })
    },
    batchMaintainExpress(pkgCodeMap, expressCodeMap) {
      let data = [...this.dataSource]
      data.forEach(item => {
        pkgCodeMap.forEach((pkg, index) => {
          if (item.pkgCode == pkg) {
            item.logisticsNo = expressCodeMap[index]
          }
        })
      })
      this.dataSource = data
    }
  },
};
</script>

<style scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.action__div--flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.span__btn {
  cursor: pointer;
  padding: 6px 0;
  min-width: 60px !important;
}

.textarea__box {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 1.5;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.textarea__box {
  outline: 0;
  border-color: #409eff;
}

.startprint {
  position: fixed;
  top: 0;
  left: 0;
  z-index: -9;
  width: 800px;
}

.uploader {
  margin: 0 10px;
}

::v-deep .el-dialog__header {
  /* padding: 10px 20px 0; */
  padding: 0px 0px 0px 0px !important;
}

.dialogTitle {
  height: 60px;
  width: 100%;
  font-size: 20px;
  text-align: center;
  line-height: 60px;
  background-color: #00284d;
  color: #e8e8e8;
}
</style>
